<template>
  <div class="management-home">
    <dashboard-home-stats/>

    <div class="dashboard-section-title">
      <div>
        <h3>وضعیت سرویس</h3>
        <p class="text-muted mb-0">پیامک، ماژول‌های فعال و فضای اشتراک</p>
      </div>
    </div>
    <dashboard-header-widget/>

    <div class="dashboard-section-title">
      <div>
        <h3>میانبرهای مدیریت</h3>
        <p class="text-muted mb-0">ورود سریع به بخش‌های فروشگاه</p>
      </div>
    </div>
    <div class="row no-gutters">
      <div
        v-for="tile in tiles"
        :key="tile.key"
        :class="tile.col"
        class="p-2"
      >
        <m-a class="resource-link" :href="{name: tile.to}">
          <div class="resource-card" :class="'skin-' + tile.skin">
            <div class="resource-icon">
              <b-icon :icon="tile.icon"/>
            </div>
            <div class="resource-body">
              <span v-if="!loading" class="resource-value">{{ items[tile.key] }}</span>
              <div v-else class="loader"></div>
              <span class="resource-label">{{ tile.label }}</span>
            </div>
            <m-a v-if="tile.create" class="resource-add" :href="{name: tile.create}">+</m-a>
          </div>
        </m-a>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardHeaderWidget from "@/plugin/components/dashboard/DashboardHeaderWidget.vue"
import DashboardHomeStats from "@/plugin/components/dashboard/DashboardHomeStats.vue"
import "@/plugin/components/dashboard/dashboard-home.css"

export default {
  name: "DashboardWidget1",
  components: {DashboardHeaderWidget, DashboardHomeStats},
  data() {
    return {
      items: {},
      loading: true,
      tiles: [
        {key: 'user', label: 'کاربران', icon: 'person', to: 'User', create: 'CreateUser', col: 'col-lg-3 col-6', skin: 'rose'},
        {key: 'products', label: 'محصولات', icon: 'box', to: 'ProductsDashboard', create: 'CreateProduct', col: 'col-lg-3 col-6', skin: 'ink'},
        {key: 'brand', label: 'برندها', icon: 'lightbulb', to: 'Brand', create: 'CreateBrand', col: 'col-lg-3 col-6', skin: 'ember'},
        {key: 'category', label: 'دسته ها', icon: 'tags', to: 'Category', create: 'Category', col: 'col-lg-3 col-6', skin: 'rose'},
        {key: 'course', label: 'دوره ها', icon: 'journal', to: 'CoursesDashboard', create: 'CreateCourse', col: 'col-lg-3 col-6', skin: 'ink'},
        {key: 'lesson', label: 'درس ها', icon: 'book-half', to: 'LessonsDashboard', create: 'CreateLessons', col: 'col-lg-3 col-6', skin: 'ember'},
        {key: 'order', label: 'سفارشات', icon: 'credit-card-fill', to: 'Orders', create: 'CreateOrder', col: 'col-lg-3 col-6', skin: 'rose'},
        {key: 'files', label: 'مدیریت فایل', icon: 'folder2', to: 'FileManager', col: 'col-lg-3 col-6', skin: 'ink'},
        {key: 'form', label: 'فرم ها', icon: 'ui-checks', to: 'Form', create: 'FormCreate', col: 'col-lg-3 col-6', skin: 'ember'},
        {key: 'chat', label: 'چت ها', icon: 'chat-dots-fill', to: 'Chats', create: 'ChatCreate', col: 'col-lg-3 col-6', skin: 'rose'},
        {key: 'offer', label: 'کدتخفیف', icon: 'receipt', to: 'Offer', create: 'Offer', col: 'col-lg-3 col-6', skin: 'ink'},
        {key: 'form_fill', label: 'پاسخ های فرم', icon: 'ui-checks-grid', to: 'Form', create: 'FormCreate', col: 'col-lg-3 col-6', skin: 'ember'},
        {key: 'comment', label: 'کامنت ها', icon: 'chat-quote-fill', to: 'Comments', create: 'Comments', col: 'col-lg-3 col-6', skin: 'rose'},
        {key: 'post', label: 'پست ها', icon: 'newspaper', to: 'PostsDashboard', create: 'CreateContent', col: 'col-lg-3 col-6', skin: 'ink'},
        {key: 'page', label: 'برگه ها', icon: 'stickies', to: 'PagesDashboard', create: 'CreateContent', col: 'col-lg-3 col-6', skin: 'ember'},
        {key: 'products_all_views', label: 'بازدید محصولات', icon: 'view-stacked', to: 'Statistic', create: 'Statistic', col: 'col-lg-3 col-6', skin: 'rose'},
      ],
    }
  },
  methods: {
    async getData() {
      try {
        const res = await this.$store.dispatch('DashboardResource/getResources')
        this.items = (res && res.data && res.data.data) || {}
      } catch (e) {
        this.items = {}
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    await this.getData()
  },
}
</script>

<style scoped>
.management-home {
  overflow-x: hidden;
  max-width: 100%;
}

.resource-link {
  display: block;
  height: 100%;
}

.loader {
  width: 45px;
  height: 20px;
  background: linear-gradient(#0000 calc(1 * 100% / 6), #fff 0 calc(3 * 100% / 6), #0000 0),
  linear-gradient(#0000 calc(2 * 100% / 6), #fff 0 calc(4 * 100% / 6), #0000 0),
  linear-gradient(#0000 calc(3 * 100% / 6), #fff 0 calc(5 * 100% / 6), #0000 0);
  background-size: 10px 400%;
  background-repeat: no-repeat;
  animation: matrix 1s infinite linear;
}

@keyframes matrix {
  0% {
    background-position: 0% 100%, 50% 100%, 100% 100%;
  }
  100% {
    background-position: 0% 0%, 50% 0%, 100% 0%;
  }
}
</style>
